import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * Watercraft icon rendered from the provided pwc.svg outline.
 */
const WatercraftIcon = props => (
  <SvgIcon viewBox="0 0 512 513" {...props}>
    <g transform="translate(-20.48 -20.48) scale(1.08)">
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M328.000000,354.000000 
	C246.179520,354.000000 164.858948,353.948334 83.538757,354.100891 
	C77.227097,354.112732 71.823097,353.115387 66.753937,349.057251 
	C56.753990,341.051758 46.264179,333.657562 36.278015,325.635773 
	C30.940262,321.347992 30.458109,315.138367 32.080910,308.891998 
	C33.683887,302.721863 38.671638,299.591644 44.223759,298.121948 
	C60.230167,293.884796 76.357391,290.099426 92.460167,286.232452 
	C105.598137,283.077423 118.772446,280.073853 131.916794,276.944916 
	C132.623993,276.776581 133.202881,276.069336 133.950516,275.535034 
	C115.612610,270.571930 97.516197,265.659760 79.410194,260.783203 
	C74.401932,259.434296 69.658058,257.699677 66.606972,253.113144 
	C62.750011,247.315292 62.535046,238.554077 67.592949,233.142075 
	C75.953987,224.195709 85.092224,215.971146 93.981110,207.524689 
	C97.869667,203.829681 102.842125,203.659500 107.780167,204.037186 
	C114.626686,204.560822 121.442856,205.506790 128.292786,205.953552 
	C136.364609,206.479980 144.464203,206.566757 152.541824,207.020828 
	C169.133453,207.953445 185.723480,208.929108 202.303711,210.042786 
	C208.820251,210.480484 215.337219,211.134918 221.802429,212.053528 
	C228.927338,213.065872 233.655045,208.162018 239.065765,205.273361 
	C252.665115,198.012970 265.973938,190.208405 280.121033,182.214172 
	C262.818115,182.214172 246.098053,182.214172 229.194000,182.214172 
	C229.194000,170.978561 229.194000,160.358658 229.194000,149.297623 
	C230.274445,149.207840 231.524811,149.015015 232.775406,149.013489 
	C249.272766,148.993271 265.775269,149.241684 282.265320,148.893860 
	C290.031006,148.730057 295.803406,152.915482 301.808502,156.464798 
	C324.938202,170.135666 347.888489,184.110291 370.891876,197.994583 
	C394.979370,212.533249 419.030243,227.132797 443.173798,241.577652 
	C444.870941,242.593063 447.182678,242.804398 449.240173,242.952805 
	C455.628876,243.413605 462.032318,243.672531 468.430847,243.993698 
	C480.064178,244.577621 484.054932,260.556396 478.697723,269.052765 
	C465.822174,289.472961 451.068787,308.309937 433.527496,324.839691 
	C419.418457,338.135132 403.865906,349.293762 384.279663,353.264587 
	C382.698853,353.585052 381.088837,353.963623 379.491364,353.968414 
	C362.494354,354.019287 345.497162,354.000000 328.000000,354.000000 
M344.796631,276.000000 
	C342.829193,276.522797 340.582306,276.602051 338.938263,277.638092 
	C324.922119,286.470795 311.140045,295.682159 296.988403,304.287628 
	C293.448273,306.440338 288.834930,307.745392 284.696075,307.792480 
	C277.538818,307.873932 270.372070,306.603973 263.200012,306.013885 
	C250.455170,304.965363 237.705246,303.976440 224.953949,303.008636 
	C211.374374,301.977966 197.795593,300.925415 184.205643,300.050415 
	C180.579605,299.816925 176.788208,299.628448 173.289398,300.400879 
	C161.373367,303.031433 149.551773,306.090973 137.698349,309.003967 
	C120.909790,313.129761 104.125000,317.270905 87.338608,321.405487 
	C87.369881,321.603668 87.401154,321.801819 87.432426,322.000000 
	C88.755577,322.000000 90.078728,322.000000 91.401878,322.000000 
	C184.684723,322.000000 277.967682,322.055267 371.250061,321.846405 
	C376.217529,321.835297 381.463776,320.258545 386.094147,318.275543 
	C403.248718,310.929077 415.142944,297.017761 427.558807,283.855316 
	C429.615997,281.674438 431.080017,278.934021 433.134827,276.000000 
	C403.368408,276.000000 374.550934,276.000000 344.796631,276.000000 
M321.643250,206.966797 
	C317.792877,205.297668 315.130402,199.973923 309.737946,203.046173 
	C301.631531,207.664642 293.554626,212.335007 285.440613,216.940018 
	C279.555847,220.279816 273.631226,223.549454 267.154236,227.168976 
	C282.879395,234.338074 297.747131,241.136642 312.634552,247.891754 
	C317.449005,250.076294 321.976868,250.535049 326.331696,246.424728 
	C327.825775,245.014511 330.371887,244.324478 332.524353,244.083923 
	C337.889191,243.484360 343.300873,243.127197 348.699432,243.044281 
	C358.744537,242.889984 368.793701,243.000000 378.841156,243.000000 
	C379.023407,242.482285 379.205658,241.964569 379.387909,241.446869 
	C360.390930,229.976105 341.393921,218.505356 321.643250,206.966797 
M224.744156,244.223236 
	C213.916443,243.482208 203.094681,242.635132 192.259521,242.026764 
	C178.429779,241.250320 164.588303,240.684708 150.753738,239.991013 
	C145.166183,239.710831 139.580582,239.374252 134.000320,238.975861 
	C132.037399,238.835709 130.093124,238.434341 128.140335,238.152252 
	C128.066040,238.603867 127.991745,239.055481 127.917442,239.507080 
	C129.946411,240.330658 131.915512,241.374557 134.013367,241.944672 
	C164.376343,250.195984 194.719131,258.526581 225.153854,266.506012 
	C235.257019,269.154877 245.565155,271.100220 255.859573,272.912842 
	C262.277557,274.042938 268.833588,274.582336 275.350739,274.877045 
	C278.759399,275.031158 283.125732,276.657288 285.303345,271.134277 
	C265.224945,262.334747 245.280426,253.593903 224.744156,244.223236 
z"
      />
      <path
        opacity="1.000000"
        fill="transparent"
        stroke="none"
        d="
M345.265076,276.000000 
	C374.550934,276.000000 403.368408,276.000000 433.134827,276.000000 
	C431.080017,278.934021 429.615997,281.674438 427.558807,283.855316 
	C415.142944,297.017761 403.248718,310.929077 386.094147,318.275543 
	C381.463776,320.258545 376.217529,321.835297 371.250061,321.846405 
	C277.967682,322.055267 184.684723,322.000000 91.401878,322.000000 
	C90.078728,322.000000 88.755577,322.000000 87.432426,322.000000 
	C87.401154,321.801819 87.369881,321.603668 87.338608,321.405487 
	C104.125000,317.270905 120.909790,313.129761 137.698349,309.003967 
	C149.551773,306.090973 161.373367,303.031433 173.289398,300.400879 
	C176.788208,299.628448 180.579605,299.816925 184.205643,300.050415 
	C197.795593,300.925415 211.374374,301.977966 224.953949,303.008636 
	C237.705246,303.976440 250.455170,304.965363 263.200012,306.013885 
	C270.372070,306.603973 277.538818,307.873932 284.696075,307.792480 
	C288.834930,307.745392 293.448273,306.440338 296.988403,304.287628 
	C311.140045,295.682159 324.922119,286.470795 338.938263,277.638092 
	C340.582306,276.602051 342.829193,276.522797 345.265076,276.000000 
z"
      />
      <path
        opacity="1.000000"
        fill="transparent"
        stroke="none"
        d="
M322.020081,207.000702 
	C341.393921,218.505356 360.390930,229.976105 379.387909,241.446869 
	C379.205658,241.964569 379.023407,242.482285 378.841156,243.000000 
	C368.793701,243.000000 358.744537,242.889984 348.699432,243.044281 
	C343.300873,243.127197 337.889191,243.484360 332.524353,244.083923 
	C330.371887,244.324478 327.825775,245.014511 326.331696,246.424728 
	C321.976868,250.535049 317.449005,250.076294 312.634552,247.891754 
	C297.747131,241.136642 282.879395,234.338074 267.154236,227.168976 
	C273.631226,223.549454 279.555847,220.279816 285.440613,216.940018 
	C293.554626,212.335007 301.631531,207.664642 309.737946,203.046173 
	C315.130402,199.973923 317.792877,205.297668 322.020081,207.000702 
z"
      />
      <path
        opacity="1.000000"
        fill="transparent"
        stroke="none"
        d="
M225.040039,244.538147 
	C245.280426,253.593903 265.224945,262.334747 285.303345,271.134277 
	C283.125732,276.657288 278.759399,275.031158 275.350739,274.877045 
	C268.833588,274.582336 262.277557,274.042938 255.859573,272.912842 
	C245.565155,271.100220 235.257019,269.154877 225.153854,266.506012 
	C194.719131,258.526581 164.376343,250.195984 134.013367,241.944672 
	C131.915512,241.374557 129.946411,240.330658 127.917442,239.507080 
	C127.991745,239.055481 128.066040,238.603867 128.140335,238.152252 
	C130.093124,238.434341 132.037399,238.835709 134.000320,238.975861 
	C139.580582,239.374252 145.166183,239.710831 150.753738,239.991013 
	C164.588303,240.684708 178.429779,241.250320 192.259521,242.026764 
	C203.094681,242.635132 213.916443,243.482208 225.040039,244.538147 
z"
      />
    </g>
  </SvgIcon>
);

export default WatercraftIcon;
